module.exports = __webpack_public_path__ + "img/cancel-volumes.bf0c1348.png";